// export const Api_Url =
//   "http://ec2-18-236-118-29.us-west-2.compute.amazonaws.com:8000";
// export const Api_Url = "https://api.dop.org";
// export const Api_Url = "http://192.168.10.189:8000";
// export const Api_Url = "http://192.168.20.27:8000";

export const Api_Url = "https://api.dop.org";
